import moment from "moment";

export const monthOptions = [
  { label: "Januari", value: 1 },
  { label: "Februari", value: 2 },
  { label: "Maret", value: 3 },
  { label: "April", value: 4 },
  { label: "Mei", value: 5 },
  { label: "Juni", value: 6 },
  { label: "Juli", value: 7 },
  { label: "Agustus", value: 8 },
  { label: "September", value: 9 },
  { label: "Oktober", value: 10 },
  { label: "November", value: 11 },
  { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from(
  { length: currentYear - 1990 + 1 },
  (_, i) => {
    const year = currentYear - i;
    return {
      label: String(year),
      value: year,
    };
  },
);

export const getConfigDaily = (role = "MEKANIK", month, year) => {
  const totalDays = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();

  const daysArray = Array.from({ length: totalDays }, (_, i) => ({
    name: String(i + 1),
    label: i + 1,
    options: { sort: false },
  }));

  return [
    {
      name: "name",
      label: role === "SA" ? "Tim SA" : "Tim Mekanik",
      options: { sort: false },
    },
    ...daysArray,
    {
      name: "total",
      label: "Total",
      options: { sort: false },
    },
    {
      name: "proyeksi",
      label: "Proyeksi",
      options: { sort: false },
    },
  ];
};

export const formatRupiah = (value) => {
  if (value === null || value === undefined) return "Rp 0";
  return `Rp ${Number(value).toLocaleString("id-ID")}`;
};

export const formatPercent = (value) => {
  if (value === null || value === undefined) return "0%";

  const num = Number(value);

  if (num === 0) return "0%";

  return `${(num * 100).toFixed(2)}%`;
};

export const getConfigYearToDate = (employeeRole, year) => [
  {
    name: "name",
    label: employeeRole === "SA" ? "Tim SA" : "Tim Mekanik",
    options: { sort: false },
  },
  {
    name: "jan",
    label: "JAN",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "feb",
    label: "FEB",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "mar",
    label: "MAR",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "apr",
    label: "APR",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "may",
    label: "MAY",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "jun",
    label: "JUN",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "jul",
    label: "JUL",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "aug",
    label: "AUG",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "sep",
    label: "SEP",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "oct",
    label: "OCT",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "nov",
    label: "NOV",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "dec",
    label: "DEC",
    options: { sort: false, customBodyRender: formatRupiah },
  },
  {
    name: "total",
    label: `YTD ${year}`,
    options: { sort: false, customBodyRender: formatRupiah },
  },
];

export const getConfigYearToDateSA = (year) => getConfigYearToDate("SA", year);

export const configMonthToDateMekanik = [
  {
    name: "partCategory",
    label: "\n",
    options: { sort: false },
  },
  {
    name: "lastMonthValue",
    label: "Last Month",
    options: {
      sort: false,
      customBodyRender: formatRupiah,
    },
  },
  {
    name: "thisMonthValue",
    label: "This Month",
    options: {
      sort: false,
      customBodyRender: formatRupiah,
    },
  },
  {
    name: "growthPercent",
    label: "Growth",
    options: {
      sort: false,
      customBodyRender: formatPercent,
    },
  },
  {
    name: "projectionSales",
    label: "Proyeksi",
    options: {
      sort: false,
      customBodyRender: formatRupiah,
    },
  },
];

export const configMonthToDate = [
  {
    name: "employeeName",
    label: "Tim Mekanik",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "220px", minWidth: "220px" },
      }),
      setCellHeaderProps: () => ({
        style: { width: "220px", minWidth: "220px" },
      }),
    },
  },
  { name: "lastMonthValue", label: "Last Month", options: { sort: false } },
  { name: "thisMonthValue", label: "This Month", options: { sort: false } },
  { name: "growthPercent", label: "Growth", options: { sort: false } },
  { name: "projectionSales", label: "Proyeksi", options: { sort: false } },
];

export const configMonthToDateSA = [
  {
    name: "employeeName",
    label: "Tim SA",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "220px", minWidth: "220px" },
      }),
      setCellHeaderProps: () => ({
        style: { width: "220px", minWidth: "220px" },
      }),
    },
  },
  { name: "lastMonthValue", label: "Last Month", options: { sort: false } },
  { name: "thisMonthValue", label: "This Month", options: { sort: false } },
  { name: "growthPercent", label: "Growth", options: { sort: false } },
  { name: "projectionSales", label: "Proyeksi", options: { sort: false } },
];

export const getConfigLast3Years = (employeeRole) => {
  return [
    {
      name: "name",
      label: "Tim Mekanik",
      options: { sort: false },
    },
    { name: "q1y2", label: "Q1 Y-2", options: { sort: false } },
    { name: "q2y2", label: "Q2 Y-2", options: { sort: false } },
    { name: "q3y2", label: "Q3 Y-2", options: { sort: false } },
    { name: "q4y2", label: "Q4 Y-2", options: { sort: false } },
    { name: "q1y1", label: "Q1 Y-1", options: { sort: false } },
    { name: "q2y1", label: "Q2 Y-1", options: { sort: false } },
    { name: "q3y1", label: "Q3 Y-1", options: { sort: false } },
    { name: "q4y1", label: "Q4 Y-1", options: { sort: false } },
    { name: "q1y", label: "Q1 Y", options: { sort: false } },
    { name: "q2y", label: "Q2 Y", options: { sort: false } },
    { name: "q3y", label: "Q3 Y", options: { sort: false } },
    { name: "q4y", label: "Q4 Y", options: { sort: false } },
  ];
};

export const getConfigLast3YearsSA = (employeeRole) => {
  return [
    {
      name: "name",
      label: "Tim SA",
      options: { sort: false },
    },
    { name: "q1y2", label: "Q1 Y-2", options: { sort: false } },
    { name: "q2y2", label: "Q2 Y-2", options: { sort: false } },
    { name: "q3y2", label: "Q3 Y-2", options: { sort: false } },
    { name: "q4y2", label: "Q4 Y-2", options: { sort: false } },
    { name: "q1y1", label: "Q1 Y-1", options: { sort: false } },
    { name: "q2y1", label: "Q2 Y-1", options: { sort: false } },
    { name: "q3y1", label: "Q3 Y-1", options: { sort: false } },
    { name: "q4y1", label: "Q4 Y-1", options: { sort: false } },
    { name: "q1y", label: "Q1 Y", options: { sort: false } },
    { name: "q2y", label: "Q2 Y", options: { sort: false } },
    { name: "q3y", label: "Q3 Y", options: { sort: false } },
    { name: "q4y", label: "Q4 Y", options: { sort: false } },
  ];
};

export const transformResponseLastThreeYearsToTable = (val = []) => {
  if (!Array.isArray(val)) return [];

  const data = val.map((item, index) => ({
    no: index + 1,
    name: item.employeeName,
    q1y2: item.y2q1,
    q2y2: item.y2q2,
    q3y2: item.y2q3,
    q4y2: item.y2q4,
    q1y1: item.y1q1,
    q2y1: item.y1q2,
    q3y1: item.y1q3,
    q4y1: item.y1q4,
    q1y: item.yq1,
    q2y: item.yq2,
    q3y: item.yq3,
    q4y: item.yq4,
  }));

  return data;
};

export const transformResponseLastThreeYearsToTableSA = (val = []) => {
  if (!Array.isArray(val)) return [];

  const data = val.map((item, index) => ({
    no: index + 1,
    name: item.employeeName,
    q1y2: item.y2q1,
    q2y2: item.y2q2,
    q3y2: item.y2q3,
    q4y2: item.y2q4,
    q1y1: item.y1q1,
    q2y1: item.y1q2,
    q3y1: item.y1q3,
    q4y1: item.y1q4,
    q1y: item.yq1,
    q2y: item.yq2,
    q3y: item.yq3,
    q4y: item.yq4,
  }));

  return data;
};

export const transformResponseMTD = (data) => {};

export const transformResponseYTD = (list = []) => {
  if (!list.length) return [];

  const rows = list.map((item) => ({
    name: item.name,
    jan: item.jan || 0,
    feb: item.feb || 0,
    mar: item.mar || 0,
    apr: item.apr || 0,
    may: item.may || 0,
    jun: item.jun || 0,
    jul: item.jul || 0,
    aug: item.aug || 0,
    sep: item.sep || 0,
    oct: item.oct || 0,
    nov: item.nov || 0,
    dec: item.dec || 0,
    total: item.total || 0,
  }));

  return rows;
};

export const transformResponseYTDSA = (list = []) => {
  return transformResponseYTD(list);
};

export const mapToSimpleNestedTable = ({ apiData, month, year }) => {
  if (!apiData?.length || !apiData[0]?.partHarian) {
    return { data: [], config: [] };
  }

  const partHarian = apiData[0].partHarian;

  // TOTAL HARI DALAM BULAN
  const daysInMonth = moment(`${year}-${month}`, "YYYY-M").daysInMonth();

  // DATA (Tanggal 1–31)
  const data = Array.from({ length: daysInMonth }, (_, i) =>
    moment(`${i + 1}-${month}-${year}`, "D-M-YYYY").format("DD/MM/YYYY"),
  );

  // CONFIG BASE
  const configMap = {
    total: {
      key: "total",
      label: "Total Part",
      dailyCash: {},
      dailyAccumulation: {},
    },
    tire: {
      key: "tire",
      label: "Tire",
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    },
    oil: {
      key: "oil",
      label: "Oil",
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    },
    battery: {
      key: "battery",
      label: "Battery",
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    },
  };

  // PART LAINNYA (DINAMIS)
  const firstDay = Object.values(partHarian)[0];
  (firstDay?.partLainnya || []).forEach((p) => {
    const key = p.partNameLainnya.toLowerCase();
    configMap[key] = {
      key,
      label: p.partNameLainnya,
      dailyCash: {},
      dailyAccumulation: {},
      percentSP: {},
    };
  });

  // DEFAULT VALUE = 0
  Object.values(configMap).forEach((col) => {
    for (let day = 1; day <= daysInMonth; day++) {
      col.dailyCash[day] = formatRupiah(0);
      col.dailyAccumulation[day] = formatRupiah(0);
      if (col.percentSP) {
        col.percentSP[day] = formatPercent(0);
      }
    }
  });

  // ISI DATA DARI API
  Object.entries(partHarian).forEach(([day, value]) => {
    const idx = Number(day);
    if (!idx || idx > daysInMonth) return;

    configMap.total.dailyCash[idx] = formatRupiah(value?.totalPart ?? 0);
    configMap.total.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiTotal ?? 0,
    );

    configMap.tire.dailyCash[idx] = formatRupiah(value?.totalTire ?? 0);
    configMap.tire.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiTire ?? 0,
    );
    configMap.tire.percentSP[idx] = formatPercent(value?.persenTire ?? 0);

    configMap.oil.dailyCash[idx] = formatRupiah(value?.totalOil ?? 0);
    configMap.oil.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiOil ?? 0,
    );
    configMap.oil.percentSP[idx] = formatPercent(value?.persenOil ?? 0);

    configMap.battery.dailyCash[idx] = formatRupiah(value?.totalBattery ?? 0);
    configMap.battery.dailyAccumulation[idx] = formatRupiah(
      value?.akumulasiBattery ?? 0,
    );
    configMap.battery.percentSP[idx] = formatPercent(value?.persenBattery ?? 0);

    (value?.partLainnya || []).forEach((p) => {
      const key = p.partNameLainnya.toLowerCase();
      if (!configMap[key]) return;

      configMap[key].dailyCash[idx] = formatRupiah(p.totalPartLainnya ?? 0);
      configMap[key].dailyAccumulation[idx] = formatRupiah(
        p.akumulasiPartLainnya ?? 0,
      );
      configMap[key].percentSP[idx] = formatPercent(p.persenPartLainnya ?? 0);
    });
  });

  return {
    data,
    config: Object.values(configMap),
  };
};
